import Component from "./Component";
import {domSelectors} from "../globals";
import $ from "jquery";
import { formNavigateTo } from "../utils";
import { getApi } from "../auth";

class LoggedUserBox extends Component {
    private _activated: boolean = false;
    constructor() {
        super(domSelectors.LoggedUserBox);
    }
    
    private uiGetUserMenuButton() {
        return this.domElement
            ? this.domElement.querySelector(domSelectors.UserMenuButton)
            : null;
    }

    private uiGetUserMenuPanel() {
        return this.domElement
            ? this.domElement.querySelector(domSelectors.UserMenu)
            : null;
    }
    
    private uiGetUserMenuExpanders() {
        return this.domElement
            ? this.domElement.querySelectorAll(domSelectors.UserMenuExpander)
            : null;
    }
    
    private uiGetUserMenuNavigatePost() {
        return this.domElement
            ? this.domElement.querySelectorAll(domSelectors.UserMenuNavigatePost)
            : null;
    }
    
    activate(): Promise<void> {
        //if (this._activated) return Promise.resolve();
        
        this.show();
        const user = getApi().getCached("userInfo");

        const userMenuButton = this.uiGetUserMenuButton();
        const userMenuPanel = this.uiGetUserMenuPanel();
        
        // click sul pulsante del menu utente: toggle del menu
        
        userMenuButton?.addOrReplaceEventListener('click', (event: Event) => {
            event.preventDefault();
            this.uiGetUserMenuPanel()?.classList.toggle('show');
        });
        
        // click esterno per chiudere il menu
        document.addOrReplaceEventListener('click', (event: Event) => {
            // Se il menu non è aperto, non fare nulla
            if (!userMenuPanel?.classList.contains('show')) return;

            // Elementi coinvolti
            const target = event.target as HTMLElement;
            // Se il click è sul menu o sul pulsante, non chiudere
            if (
                userMenuPanel?.contains(target) ||
                userMenuButton === target ||
                (userMenuButton && userMenuButton.contains(target))
            ) {
                return;
            }
            // Altrimenti chiudi il menu
            userMenuPanel?.classList.remove('show');
        });
        
        // click su un elemento del menu: toggle del sotto-menu
        this.uiGetUserMenuExpanders()?.forEach((expander) => {
            expander.addOrReplaceEventListener('click', (event: Event) => {
                event.preventDefault();
                const arrow = expander.querySelector('.arrow');
                const subMenu = expander.parentElement?.nextElementSibling;

                if (arrow && subMenu) {
                    arrow.classList.toggle('active');
                    subMenu.classList.toggle('show');
                }
            });
        });
        
        this.uiGetUserMenuNavigatePost()?.forEach((item) => {
            item.addEventListener('click', (event: Event) => {
                event.preventDefault();
                const action = item.getAttribute('data-action');
                if (action) {
                    formNavigateTo(action,"POST", {
                        token: user.accessToken,
                        userAnagraficaId: user.anagraficaId,
                        userid: user.anagraficaId
                    }).then();
                }});
        })
        
        this._activated = true;
        return Promise.resolve();
    }
   
    
}

export default LoggedUserBox;